module.exports = __webpack_public_path__ + "static/media/protocol.b4580d9a.htm";